export const SLIDESHOW_DELAY = 5000;

export const SLIDESHOW_QUEUES = [
  { label: "Single queue for all monitors", value: 1 },
  { label: "Each monitor own queue", value: 2 },
];
